import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ExclamationMark = ({
  size,
  type,
  theme,
  className,
  dataTestId = "exclamation-mark-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M7.35147 12.769C7.35147 13.4488 7.8654 14 8.49936 14C9.13332 14 9.64725 13.4488 9.64725 12.769C9.64725 12.0891 9.13332 11.5379 8.49936 11.5379C7.8654 11.5379 7.35147 12.0891 7.35147 12.769Z" />
    <path d="M9.16984 3C9.67559 3 10.0638 3.48094 9.99127 4.01772L9.2185 9.73956C9.18894 9.95844 9.014 10.1208 8.80778 10.1208H8.19222C7.986 10.1208 7.81106 9.95844 7.7815 9.73956L7.00873 4.01772C6.93624 3.48094 7.32441 3 7.83016 3H9.16984Z" />
  </SVGIcon>
);
